module.exports = __webpack_public_path__ + "media/images/app/icon-0dd0bbf43ca5c556b6be35aeaa76d88e.jpg";